// @flow
import * as React from 'react';
import { CloudDownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Input, Menu, Upload, Button, Dropdown } from 'antd';
import { connect } from 'react-redux';
import { PERMISSIONS, createPermitFunction } from '../../../Evolve/Utilities/permissions';
import { isAdmin } from 'Common';

const styles = {

  stack: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 25
  },

  heading: {
    flex: 1,
    margin: 0
  }
}

type Props = {
  searchTerm: string,
  userPermissions: [],
  onChangeSearch: () => void,
  onSubmitSearch: () => void,
  onUpload: () => void,
  onClickExport: () => void
}

class Header extends React.PureComponent<Props> {

  render () {
    const {
      searchTerm,
      userPermissions,
      onSubmitSearch,
      onChangeSearch,
      onUpload,
      onClickExport
    } = this.props;

    const permit = createPermitFunction(userPermissions);

    const exportMenu = (
      <Menu onClick={onClickExport}>
        <Menu.Item key="excel">Export to Excel</Menu.Item>
        <Menu.Item key="csv">Export to CSV</Menu.Item>
      </Menu>
    );

    return (
      <div style={styles.stack}>

        <h1 style={styles.heading}>
          Profit & Loss
        </h1>

        <Input.Search
          value={searchTerm}
          onChange={onChangeSearch}
          onSearch={onSubmitSearch}
          placeholder="Search"
          enterButton
          style={{ width: 250 }}
        />
        
        {(isAdmin() && permit('exports')) && (

          <React.Fragment>
          
            <div style={{ width: 10 }} />

            <Upload
              name="file"
              customRequest={onUpload}
              showUploadList={false}
            >
              <Button icon={<UploadOutlined />} style={{ width: 50, fontSize: 18 }} />
            </Upload>
          
            <div style={{ width: 10 }} />

            <Dropdown overlay={exportMenu}>
              <Button>
                <CloudDownloadOutlined style={{ fontSize: 16, marginTop: 3 }} />
              </Button>
            </Dropdown>
          
          </React.Fragment>

        )}

      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userPermissions: (state.user && state.user.permissions) || [],
})

export default connect(mapStateToProps)(Header)